import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installation-payment-method',
  templateUrl: './installation-payment-method.component.html',
  styleUrls: ['./installation-payment-method.component.scss']
})
export class InstallationPaymentMethodComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
